import './customCard.scss';

export const CustomCardTemplate = (model) => {
	const { message_id } = model;

	const html = `
        <div class="engt-custom-card-node-container" id="engt-custom-card-node-container-id${message_id}" style="margin-bottom: 10px; margin-top: 10px; margin-left: 5px;"></div>
    `;

	return html;
};
